import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GameShareData } from '@features/games/models/game-share-data';
import { ProductionGameDetailsPage } from '@features/games/models/production-game-details-page';
import { BehaviorSubject, Observable, Subject, tap } from 'rxjs';

@Injectable()
export class ProductionGamePageService {

  private pageUrl = '/games/gamedetails/{id}/page'; 
  private shareUrl = '/games/gamedetails/{id}/share';  
  
  private http = inject(HttpClient);

  private pageSubject$ = new BehaviorSubject<ProductionGameDetailsPage | undefined>(undefined);
  
  public get page$() : Observable<ProductionGameDetailsPage | undefined> {
    return this.pageSubject$.asObservable();
  }

  constructor() { }

  public getPage(gameDetailsId: string): Observable<ProductionGameDetailsPage> {
    return this.http.get<ProductionGameDetailsPage>(this.pageUrl.replace('{id}', gameDetailsId)).pipe(
      tap(page => {
        this.pageSubject$.next(page);
      })
    );
  }

  public Share(gameShare: GameShareData): Observable<void> {
    return this.http.post<void>(this.shareUrl, gameShare);
  }

}
